import React, { Component } from 'react'
import './styles.css'
import { apiEmployee } from '../../services/apiamrg'
import Header from '../../components/header'
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import Select from 'react-select'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { Squares } from "react-activity";
import Util from '../../classes/util'
import Alert from '../../components/alert'
import { Input } from '@material-ui/core'

const estadoInicial = {
    usuario: {},

    chave: 0,
    chave_pessoa: 0,
    cpf: '',
    nome: '',
    senha: '',
    senhaConfirmar: '',
    telefone: '',

    alert: { type: '', msg: '' },

    textOptions: '',

    loading: false,
    redirect: false,
}

class AddUsuario extends Component {

    state = {
        ...estadoInicial
    }

    setEmpresa = () => {
        if (this.props.id === 999999) {
            this.setState({
                empresa: localStorage.getItem('empresaID')
            })
        } else {
            this.setState({
                empresa: this.props.empresa
            })
        }
    }

    componentDidMount = async () => {
        const { id } = this.props.match?.params;

        if (id != 0) {
            this.loadUsuario(id);
        }

        this.loadAll();
        this.setEmpresa();
    }

    loadUsuario = async (id) => {
        this.setState({ chave: id });

        const usuario = await apiEmployee.get(`tickets/usuarios/get/${id}`,
        ).then(
            (res) => { if (res.data[0]) return res.data[0] },
            (err) => console.error(err)
        ).catch((err) => console.error(err));

        this.setState({
            nome: usuario?.nome,
            cpf: usuario?.cpf,
            telefone: usuario?.telefone?.replace(/(\d{2})(\d{2})(\d{4})(\d{5})/, '+$1 ($2) $3-$4')
        })
    }

    loadAll = async () => {
    }

    saveUsuario = async () => {
        let telefone = this.state.telefone?.replace(/[^0-9]/gi, '');

        if (telefone.length === 9) {
            telefone = `5553${telefone}`;
        } else if (telefone.length === 11) {
            telefone = `55${telefone}`;
        }

        if (this.state.chave == 0) {
            await apiEmployee.post('tickets/usuarios/salvar',
                {
                    cpf: this.state.cpf,
                    nome: this.state.nome,
                    senha: this.state.senha,
                    telefone,
                    empresa: this.state.empresa
                }).then(
                    (res) => { this.setState({ redirect: true }) },
                    (err) => console.error(err)
                ).catch((err) => console.error(err));
        } else {
            await apiEmployee.put(`tickets/usuarios/editar/${this.state.chave}`,
                {
                    cpf: this.state.cpf,
                    nome: this.state.nome,
                    senha: this.state.senha,
                    telefone,
                    empresa: this.state.empresa
                }).then(
                    (res) => { this.setState({ redirect: true }) },
                    (err) => console.error(err)
                ).catch((err) => console.error(err));
        }
    }

    filterOptions = (item) => {
        if (!this.state.textOptions) {
            return true;
        }

        return item?.label?.toLowerCase().indexOf(this.state.textOptions?.toLowerCase()) != -1;
    }


    render() {
        const validations = [];
        validations.push(this.state.cpf && [11, 14].includes(this.state.cpf.length));
        validations.push(this.state.nome);
        validations.push(this.state.senha);
        validations.push(this.state.senhaConfirmar == this.state.senha);
        validations.push(!this.state.telefone || [9, 11, 13].includes(this.state.telefone?.replace(/[^0-9]/gi, '').length));


        const validForm = validations.reduce((t, a) => t && a)

        return (
            <div>
                {this.state.redirect &&
                    <Redirect to={'/usuarios'} />
                }

                <Alert
                    alert={this.state.alert}
                    setAlert={(value) => this.setState({ alert: value })}
                />

                <Header voltarUsuario />
                <div className='centrom'>
                    <div className="col-sm-12 col-md-12 col-lg-9 col-xl-9 row containeralterarcardapio" >
                        <Link to={{ pathname: `/usuarios` }} style={{ color: "#DE3338", size: "30px", margin: "10px" }}>X</Link>
                        <div className="form_body">
                            <div className='col-12 contcard'>
                                <span>Cpf *</span>

                                <input
                                    className='form_input'
                                    placeholder="00000000000"
                                    value={this.state.cpf}
                                    maxLength={14}
                                    onChange={a => this.setState({ cpf: a.currentTarget.value })} />
                            </div>

                            <div className='col-12 contcard'>
                                <span>Nome *</span>

                                <input className='form_input' placeholder="Nome do usuário" value={this.state.nome} onChange={a => this.setState({ nome: a.currentTarget.value })} />
                            </div>

                            <div className='col-12 contcard'>
                                <span>Senha *</span>

                                <input className='form_input' type={"password"} placeholder="Senha padrão" value={this.state.senha} onChange={a => this.setState({ senha: a.currentTarget.value })} />
                            </div>

                            <div className='col-12 contcard'>
                                <span>Confirmar Senha *</span>

                                <input className='form_input' type={"password"} placeholder="Confirmar Senha padrão" value={this.state.senhaConfirmar} onChange={a => this.setState({ senhaConfirmar: a.currentTarget.value })} />
                            </div>

                            <div className='col-12 contcard last_field'>
                                <span>Telefone</span>

                                <input
                                    className='form_input'
                                    placeholder="+55 00 000000000"
                                    value={this.state.telefone}
                                    onChange={a => this.setState({ telefone: a.currentTarget.value })} />
                            </div>
                        </div>

                        <div className='col-12 contvtt'>
                            <button type='button' className='button_salvar' disabled={!validForm} onClick={() => validForm ? this.saveUsuario() : {}}>Salvar</button>

                            {this.state.loading && <Squares color={'black'} size={40} speed={0.5} />}
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        token: user.token,
        id: user.id,
        cnpj_cpf: user.cnpj_cpf,
        nome: user.nome,
        empresa: user.empresa,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(AddUsuario)